import { useEffect, useState } from 'react';
import { subscribeLoginChannelReady, LoginChannelState } from '../utils/loginChannelEvent';

interface UseLoginChannelLogoOptions {
  scene?: string;
}

function resolveAsset(state: LoginChannelState, defaultAsset: string, rjAsset: string): string {
  return state.isRJ ? rjAsset : defaultAsset;
}

export function useLoginChannelLogo(
  defaultAsset: string,
  rjAsset: string,
  options?: UseLoginChannelLogoOptions
): string | null {
  const scene = options?.scene ?? 'logo';
  const [asset, setAsset] = useState<string | null>(null);

  useEffect(() => {
    const handleChannelReady = (state: LoginChannelState) => {
      setAsset(resolveAsset(state, defaultAsset, rjAsset));
      console.log(`[useLoginChannelLogo:${scene}]`, 'channel ready from event', {
        isRJ: state.isRJ,
        channel: state.channel,
        version: state.version
      });
    };

    return subscribeLoginChannelReady(handleChannelReady);
  }, [defaultAsset, rjAsset, scene]);

  return asset;
}
